import CsvTable from "src/components/shared/csvTable/csvTable";
import Plot from "react-plotly.js";
import BotMessage from "src/components/shared/botMessage/botMessage";
import EmptyChartMessage from "src/components/shared/emptyChartMessage/EmptyChartMessage";
import { DEFAULT_PLOTLY_CONFIG } from "src/constants/constants";
import { ConfirmationTurn } from "../../types";
import UserFeedback from "./userFeedback/userFeedback";

interface ChartBlockProps {
  chartJson?: any;
  turn: ConfirmationTurn;
  csvPreview?: string;
  csvData?: string;
}

const ChartBlock = ({
  chartJson,
  turn,
  csvPreview,
  csvData,
}: ChartBlockProps) => {
  return (
    <>
      <BotMessage maxWidth="557px" className="chat-messages__message">
        {turn.emptyData ? (
          <EmptyChartMessage />
        ) : (
          <>
            {turn.numericalAnswer && (
              <div style={{ width: "525px" }}>{turn.numericalAnswer}</div>
            )}

            {turn.showCsv && csvPreview ? (
              <CsvTable csvPreview={csvPreview} csvData={csvData} />
            ) : (
              chartJson && (
                <Plot
                  style={{ width: "525px", height: "336px" }}
                  data={chartJson.data}
                  layout={chartJson.layout}
                  config={DEFAULT_PLOTLY_CONFIG}
                />
              )
            )}
          </>
        )}
        {turn?.voteUp !== null && (
          <UserFeedback
            voteUp={turn.voteUp}
            downvoteReason={turn.downvoteReason}
          />
        )}
      </BotMessage>
    </>
  );
};

export default ChartBlock;
